import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import * as Selectors from 'state/selectors'
import * as Actions from 'state/actions'
import { find } from 'shared/utils/array'

const FILTER_TYPE = 'filter',
      INBOX_TYPE = 'inbox'

const RouteHandler = () => {
  const historyParams = useParams()

  //redux logic
  const organisation = useSelector(Selectors.getActiveOrganisation)

  const inboxes = useSelector(Selectors.getInboxesState).collection
  const interactions = useSelector(Selectors.getInteractions)

  const selectedFilter = useSelector(Selectors.getSelectedFilter)
  const selectedInbox = useSelector(Selectors.getSelectedInbox)
  const selectedInteraction = useSelector(Selectors.getSelectedInteraction)

  const dispatch = useDispatch()
  const selectInbox = inbox => dispatch(Actions.selectInbox(inbox))
  const selectFilter = filter => dispatch(Actions.selectFilter(filter))
  const selectInteraction = interaction => dispatch(Actions.selectInteraction(interaction))
  const fetchInteraction = interactionId => dispatch(Actions.interactionInfoRequest(interactionId))

  useEffect(() => {
    if(!organisation) {
      return
    }

    if(
      historyParams.filterType === FILTER_TYPE &&
      typeof historyParams.filterId === 'string' &&
      historyParams.filterId !== selectedFilter
    ) {
      selectFilter(historyParams.filterId)
      return
    }

    if(
      historyParams.filterType === INBOX_TYPE &&
      typeof historyParams.filterId === 'string' &&
      historyParams.filterId !== `${selectedInbox?.inboxId}`
    ) {
      const inboxIdToFind = historyParams.filterId
      const inboxToSelect = find(inboxes, inbox => `${inbox.inboxId}` === inboxIdToFind)

      if(inboxToSelect) selectInbox(inboxToSelect)
      return
    }
    
    if(
      typeof historyParams.interactionId === 'string' &&
      historyParams.interactionId !== selectedInteraction?.interactionId
    ) {
      const interactionIdToFind = historyParams.interactionId
      const interactionToSelect = find(
        interactions,
        interaction => interaction.interactionId === interactionIdToFind
      )

      if(interactionToSelect) {
        selectInteraction(interactionToSelect)
      } else {
        fetchInteraction(historyParams.interactionId)
      }

      return
    }
  })

  return null
}

export default RouteHandler
